import React, { useState, useEffect, useContext } from "react";
import ArticleIcon from '@mui/icons-material/Article';
import IconButton from "@mui/material/IconButton";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TableViewIcon from '@mui/icons-material/TableView';
import Tooltip from "@mui/material/Tooltip";
import { LanguageContext } from "./LanguageContext";

export const ExportDataButtons = ({ handlePDF, handleWord, handleExcel }) => {

    // Toistuvat muuttujat
    const { dictionary } = useContext(LanguageContext);

    return (
        <React.Fragment>
            <Tooltip title={dictionary.MuiDataTable.textLabels.toolbar.downloadPDF}>
                <IconButton onClick={handlePDF}>
                    <PictureAsPdfIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title={dictionary.MuiDataTable.textLabels.toolbar.downloadWord}>
                <IconButton onClick={handleWord}>
                    <ArticleIcon />
                </IconButton>
            </Tooltip>

            <Tooltip title={dictionary.MuiDataTable.textLabels.toolbar.downloadExcel}>
                <IconButton onClick={handleExcel}>
                    <TableViewIcon />
                </IconButton>
            </Tooltip>
        </React.Fragment>
    );
}
